<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onResetSearch">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Số folio' }}
                </div>
                <div class="">
                  <input
                    v-model="searchParams.folioNum"
                    type="text"
                    placeholder=""
                  />
                </div>
              </div>
            </div>

            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Recode' }}
                </div>
                <div class="">
                  <input
                    v-model="searchParams.recode"
                    type="text"
                    placeholder=""
                  />
                </div>
              </div>
            </div>

            <!-- <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Khách sạn' }}
                </div>
                <div class="child-w-80">
                  <el-select
                    v-model="searchParams.hotelIds"
                    multiple
                    collapse-tags
                  >
                    <el-option
                      v-for="(hotel, index) in hotelList"
                      :key="index"
                      :value="hotel.id"
                      :label="hotel.name"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div> -->
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Loại giao dịch' }}
                </div>
                <div class="child-w-80">
                  <el-select v-model="searchParams.type" collapse-tags>
                    <el-option
                      v-for="(item, index) in typeOptions"
                      :key="index"
                      :value="item.id"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Người sửa</div>
                <div class="child-w-80">
                  <el-select
                    v-model="searchParams.accountId"
                    clearable
                    filterable
                    collapse-tags
                  >
                    <el-option
                      v-for="(item, index) in accountOptions"
                      :key="index"
                      :value="item.account.id"
                      :label="`(${item.account.username}) ${item.account.full_name}`"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Từ ngày - Đến ngày</div>
                <div class="child-w-80">
                  <CalendarRange
                    v-model="datetimeRange"
                    style="display: block; width: 500px"
                    mode="date"
                    @input="setDateRange"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container" style="display: flex">
            <div class="das-form-title">
              <span class="main-title">
                {{ `Báo cáo điều chỉnh giao dịch` }}
              </span>
            </div>

            <DownloadBtn
              @exportExcel="exportExcel"
              @openNoteDialog="dialogNoteVisible = true"
            />
          </div>
          <hr />

          <div class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              dom-layout="scroll"
              :header-height-setter="headerHeightSetter"
              :is-header-height-setter="true"
              :default-col-def="defaultColDef"
              class="agGrid"
              :auto-size-cell="true"
            />
          </div>
        </div>
      </div>
    </div>

    <NoteDialog v-model="dialogNoteVisible">
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>Recode: Mã đặt phòng</li>
            <li>Số hóa đơn: hiển thị số hóa đơn có giao dịch được chỉnh sửa</li>
            <li>
              Giá tiền trước khi sửa: Hiển thị giá tiền của hóa đơn trước khi
              sửa hóa đơn
            </li>
            <li>
              Giá tiền sau khi sửa: Hiển thị giá tiền sau khi hóa đơn được thay
              đổi
            </li>
            <li>
              Thời gian sửa: Hiển thị thời gian thao tác sửa hóa đơn. format :
              DDMMYYYY HHMMSS
            </li>
            <li>
              Người sửa: Hiển thị Họ và tên người thực hiện thao tác sửa hóa đơn
            </li>
            <li>Lấy dữ liệu khi thu ngân/Lễ tân thực hiện</li>
            <li>***Lưu ý:</li>
            <li>
              với cột có giá trị là tiền tự động hiển thị dấu phẩy ngăn cách. Ví
              dụ: 100000 (1 triệu) hiển thị 1,000,000
            </li>
          </ul>
        </div>
      </div>
    </NoteDialog>
  </div>
</template>

<script>
/* eslint-disable */
import DownloadBtn from './components/DownloadBtn.vue'
import NoteDialog from './components/NoteDialog.vue'
import { HtmlCellRender } from '@/utils/cellRenders'

import {
  getUpdateInvoiceReport,
  getUpdateInvoiceReportExcel
} from '@/api/report_service/datntReport'
import { getAllHotel } from '@/api/hotel'
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import { getReceptionestOptions } from '@/api/report_service/miniBarReport'

import { formatVND } from '@/utils/commonUtils'

export default {
  components: { DownloadBtn, NoteDialog, HtmlCellRender, CalendarRange },
  data() {
    return {
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        suppressMovable: true,
        wrapText: true,
        autoHeight: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },
      searchParams: {
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        folioNum: null,
        recode: null,
        hotelIds: [],
        type: null,
        accountId: null
      },
      defaultSearchParams: {
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        folioNum: null,
        recode: null,
        hotelIds: [],
        type: null,
        accountId: null
      },
      defaultDatetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },
      datetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },

      // data for search
      hotelList: [],
      accountOptions: [],
      typeOptions: [
        {
          id: 1,
          label: 'Điều chỉnh'
        },
        {
          id: 2,
          label: 'Xóa'
        }
      ],

      // grid
      columns: [
        {
          headerName: 'Recode',
          tooltipField: 'recode',
          field: 'recode',
          minWidth: 120,
          maxWidth: 160
        },
        {
          headerName: 'Số Folio',
          field: 'folio_num',
          tooltipField: 'folio_num',
          minWidth: 100,
          maxWidth: 130
        },
        {
          headerName: 'Loại giao dịch',
          field: 'sub_transaction_name',
          tooltipField: 'sub_transaction_name',
          minWidth: 100,
          maxWidth: 130
        },
        {
          headerName: 'Thao tác',
          field: 'type',
          cellRenderer: params => {
            if (params.value === 1) return 'Điều chỉnh'
            else if (params.value === 2) return 'Xóa'
            return null
          },
          tooltipField: 'type',
          tooltipValueGetter: params => {
            if (params.value === 1) return 'Điều chỉnh'
            else if (params === 2) return 'Xóa'
            return null
          },
          minWidth: 100,
          maxWidth: 130
        },
        {
          headerName: 'Giá tiền trước khi sửa',
          // field: 'money_from',
          cellClass: 'ag-cell-right',
          // tooltipField: 'recode',
          tooltipValueGetter: params => formatVND(params.data.money_from, null),

          valueGetter: params => formatVND(params.data.money_from, null),
          minWidth: 100,
          maxWidth: 130
          // valueGetter: params => formatVND(params.data.money_from, 'VND ')
        },
        {
          headerName: 'Giá tiền sau khi sửa',
          // field: 'money_to',
          cellClass: 'ag-cell-right',
          tooltipValueGetter: params => formatVND(params.data.money_to, null),
          valueGetter: params => formatVND(params.data.money_to, null),
          minWidth: 100,
          maxWidth: 150
        },
        {
          headerName: 'Thông tin sửa',
          field: 'content',
          tooltipField: 'content',
          cellRenderer: 'HtmlCellRender',
          cellRendererParams: params => {
            return {
              contents: params.data.contents
            }
          },
          minWidth: 500,
          flex: 1
        },
        {
          headerName: 'Thời gian sửa',
          field: 'create_date',
          tooltipField: 'create_date',

          minWidth: 100,
          maxWidth: 190
        },
        {
          headerName: 'Người sửa',
          field: 'create_user',
          tooltipField: 'create_user',

          minWidth: 100,
          maxWidth: 180
        }
      ],
      rows: [],

      // dialog
      dialogNoteVisible: false
    }
  },

  async mounted() {
    await this.getListHotel()
    this.getAccountList()
    await this.fnGetUpdateInvoiceReport()
  },

  methods: {
    async getAccountList() {
      const data = await getReceptionestOptions()
      this.accountOptions = data.data || []
    },
    onSearch() {
      this.fnGetUpdateInvoiceReport()
    },
    onResetSearch() {
      this.datetimeRange = { ...this.defaultDatetimeRange }
      this.searchParams = { ...this.defaultSearchParams }
      this.fnGetUpdateInvoiceReport()
    },
    setDateRange(range) {
      this.searchParams.dateFrom = range.start
      this.searchParams.dateTo = range.end
    },

    // handle api call
    async fnGetUpdateInvoiceReport() {
      try {
        const res = await getUpdateInvoiceReport(this.searchParams)
        this.rows = res.data
      } catch (error) {
        this.$message({
          type: 'error',
          message: this.$t(
            'errorMsg.' + error?.response?.data?.message
              ? error?.response?.data?.message
              : error
          )
        })
      } finally {
        //
      }
    },
    exportExcel() {
      getUpdateInvoiceReportExcel(this.searchParams).then(res => {
        if (res) {
          const date = this.$moment().format('DD-MM-YYYY')
          const href = URL.createObjectURL(res)
          // create "a" HTML element with href to file & click
          const link = document.createElement('a')
          link.href = href
          link.setAttribute(
            'download',
            'dieu_chinh_giao_dich_report_' + date + '.xlsx'
            // res.headers['content-disposition'].split('filename=')[1],
          ) // or any other extension
          document.body.appendChild(link)
          link.click()
          // clean up "a" element & remove ObjectURL
          document.body.removeChild(link)
          URL.revokeObjectURL(href)
        } else {
          throw new Error(res)
        }
      })
    },
    async getListHotel() {
      const data = await getAllHotel()
      this.hotelList = data.data
    },
    headerHeightGetter() {
      var columnHeaderTexts = [
        ...document.querySelectorAll('.ag-header-cell-text')
      ]
      var clientHeights = columnHeaderTexts.map(
        headerText => headerText.clientHeight
      )
      var tallestHeaderTextHeight = Math.max(...clientHeights)

      return tallestHeaderTextHeight
    },

    headerHeightSetter() {
      var padding = 40
      var height = this.headerHeightGetter() / 2 + padding
      this.$refs.agGrid.gridApi.setHeaderHeight(height)
      this.$refs.agGrid.gridApi.resetRowHeights()
    }
  }
}
</script>
